<script lang="ts">
  import type { SharedOrder } from "@shared/types/Order";

  export let order: SharedOrder;
  export let tabs: string[] = [];
  export let selectedTab: { name?: string } = {};

</script>

<div class="padding-bottom--small hide--md">
  <ul
    class="order-tab-content tabs list list--horizontal list--gutter-none align-center margin-left--small margin-right--small hide--md"
  >
    {#each tabs as tab}
      <li class="list-item secondary-body--regular">
        <div
          class="capitalize cursor-pointer tabs__tab padding--small"
          class:tabs__tab--active={selectedTab.name == tab}
          on:click={() => {
            selectedTab.name = tab;
          }}
        >
          {tab}
          {#if tab == "events" && order.unread_events > 0}
            <span
              class="order-index__order-notification order-detail-event-notifications background-brandSecondary margin-left--smallest--sm light-small--regular align-center display-inline-block"
            >
              {order.unread_events}
            </span>
          {/if}
        </div>
      </li>
    {/each}
  </ul>
</div>
